import styled from 'styled-components'

const Heading = styled.div`
  color: ${props => props.theme.color.palette['brand-1']};
`

export { Heading }
